export default "__VITE_ASSET__kQL$tT0V__"